"use strict";

import { http } from '../../core';
import config from "../../app.config";
const RequestbaseURL = http.create({baseURL:config.BASEURL});

export default {
    getdictionary(){
        return RequestbaseURL.get("appcenter/apptree/v1/data/dictionary")
    },
    serverList(params) {
        return RequestbaseURL.get('appcenter/apptree/server/v1/list', params)
    },

    addServer(params) {
        return RequestbaseURL.post('appcenter/apptree/server/v1/add', params)
    },

    delServer(params) {
        return RequestbaseURL.post('appcenter/apptree/server/v1/delete', params)
    },

    updateServer(params) {
        return RequestbaseURL.post('appcenter/apptree/server/v1/update', params)
    },

    serverGroupList(params) {
        return RequestbaseURL.get('appcenter/apptree/servergroup/v1/list', params)
    },

    serverInfo(params) {
        return RequestbaseURL.get('appcenter/apptree/server/v1', params)
    },

    envList() {
        return RequestbaseURL.get('appcenter/apptree/server/v1/env/list')
    }

}
